<script setup lang="ts">
import Box from '@uiKit/elements/Box.vue'
import Text from '@uiKit/elements/Text.vue'
import PiIcon, { type PiIconName } from '@uiKit/elements/PiIcon.vue'

// Icon + title + subline at the top of the sell outcome screens (Figma
// "Hero", 34433:273403 / 273444).

interface Props {
  icon: PiIconName
  tone: 'warning' | 'danger'
  title: string
  subtitle: string
}

defineProps<Props>()
</script>

<template>
  <Box direction="col" align="center" gap="3" class="sell-hero">
    <Box align="center" justify="center" :class="['sell-hero__icon', `sell-hero__icon--${tone}`]">
      <PiIcon :name="icon" class="sell-hero__glyph" />
    </Box>
    <Text is="h3" type="title-lg" weight="semibold" align="center" class="sell-hero__title">{{
      title
    }}</Text>
    <Text type="body-sm" color="var(--p-surface-500)" align="center">{{ subtitle }}</Text>
  </Box>
</template>

<style scoped>
.sell-hero {
  padding-top: 10px;
}

.sell-hero__icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
}

.sell-hero__icon--warning {
  background: var(--p-warning-50);
  color: var(--p-warning-600);
}

.sell-hero__icon--danger {
  background: var(--p-danger-50);
  color: var(--p-danger-600);
}

.sell-hero__glyph {
  font-size: 26px;
}

.sell-hero__title {
  margin: 0;
  line-height: 1.3;
}
</style>
